<div [fxLayout]="to.fxLayout" [fxLayoutAlign]="to.fxLayoutAlign" fxLayout.xs="column" class="container-content">
  @for (f of field.fieldGroup; track f) {
    <formly-field class="teiar-flex" [field]="f"></formly-field>
  }
</div>